"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = hasDetectedInsightsClient;

function hasDetectedInsightsClient() {
  return typeof window !== 'undefined' && Boolean(window.AlgoliaAnalyticsObject);
}